import { Paper, Typography } from "mpulse-design-system";

import { styled, Skeleton } from "@mui/material";

const InfoCard = (props) => {
  return (
    <PaperStyled variant="elevation">
      <Typography variant="h3" color="textPrimary" style={{ flexGrow: "1" }}>
        {props.title}
      </Typography>
      <Typography variant="h2" color="textPrimary">
        {props.count || props.count === 0 ? (
          props.count
        ) : (
          <Skeleton width={32} height={32} />
        )}
      </Typography>
    </PaperStyled>
  );
};

const PaperStyled = styled(Paper)(({ theme }) => ({
  "&.MuiPaper-root": {
    minHeight: "89px",
    padding: `${theme.spacing(2.5)}`,
  },
}));

export default InfoCard;
